<template>
<!--  <div>-->
    <b-form-group>
      <label  v-html="fieldsData.label[selectlang]"></label>
<!--{{fieldsData}}-->
<!--{{typeof fieldsData}}-->
        <b-form-radio-group
            v-model="selectedradioOptions"
            :required="isRequired(fieldsData.required)"
            :options="options"
            :state="state"
            :name="fieldsData.name"
            class="demo-inline-spacing"
            @input="UpdateValue"

        ></b-form-radio-group>

<!--      <small class="text-danger" v-if="fieldsData.id==''">{{ fieldsData.error[selectlang] }}</small>-->
    </b-form-group>
<!--  </div>-->
</template>


<script>

import { BFormRadioGroup,} from "bootstrap-vue";
export default {

  props: ['fieldsData','selectlang'],
  components: {

    BFormRadioGroup,
  },
  data() {
    return {

      // errors: [],
      DataArray:{},
      selectedValues: {},
      selectedradioOptions:[],
     // Assuming this is your v-model
      state: null, // Assuming this is your state
      options: [],
    };
  },


  mounted() {
    // Populate options array with data from fieldsData['string-array']
    // this.options = this.fieldsData['string-array'].map(option => {
    //   return { text: option.title, value: option.id };
    // });
    this.options = this.fieldsData['string-array'].map(option => {
      return { text: option.title, value: String(option.id) };
    });

  },
  created() {
    if (typeof this.fieldsData.id === 'number') {
      //   // If this.fieldsData.id is a number, convert it to a string
      this.selectedradioOptions = this.fieldsData.id.toString();
      this.UpdateValue(this.selectedradioOptions )

    }
    else if (typeof this.fieldsData.id === 'string') {
      this.selectedradioOptions = this.fieldsData.id;
      this.UpdateValue(this.selectedradioOptions )
    }
    else{

      // console.log( typeof this.selectedradioOptions)
      this.selectedradioOptions = this.fieldsData.id.split(',').map(item => parseInt(item.trim()));
      this.UpdateValue(this.selectedradioOptions )
    }


    // }
  },


  methods: {
    isRequired(requiredValue) {

      // Check if fieldsData.required is equal to 1
      return requiredValue == 1;
    },
    UpdateValue(value) {

      // console.log(value);
      this.$emit('input', value)
    },

  },
}
</script>

<style>
/* Add your styles here */
</style>
